import React from "react";
import { CustomSubHeader } from "../../../components/subheader";
import { SubheaderNav } from "../../../components/subheader/subheaderNav";

export default function GatewayAndPriceSubheader({ tabName, children }) {
  const links = [
    { name: "SMS Pricing", to: "/gateway-and-price/sms", icon: "bi bi-chat" },
    { name: "Email Pricing", to: "/gateway-and-price/email", icon: "bi bi-envelope" },
    { name: "Whatsapp Pricing", to: "/gateway-and-price/whatsapp", icon: "bi bi-envelope" },
    { name: "Whatsapp Pricing 2", to: "/gateway-and-price/whatsapp-2", icon: "bi bi-envelope" },
    { name: "RCS", to: "/gateway-and-price/rcs", icon: "bi bi-chat-dots" },
  ];
  return (
    <CustomSubHeader>
      <div className="w-100 d-flex flex-stack">
        <SubheaderNav links={links} active={tabName} />
        <div>
          {children}
        </div>
      </div>
    </CustomSubHeader>
  );
}
